import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';
import { SenderService } from '../services/sender.service';
import {
  fetchSenderList,
  loadedSenderList,
  failedSenderList,
  updateSenderListFilter,
} from './sender-list.actions';
import { selectSenderListFilter } from './sender-list.selector';

@Injectable()
export class SenderListEffect {
  loadSenderList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchSenderList),
      switchMap(({ filter }) =>
        this.senderService.getSenderList(filter).pipe(
          map(res => {
            if (res.success) {
              return loadedSenderList({
                dataSource: {
                  totalRecords: res.response.totalRecords,
                  page: res.response.page,
                  count: res.response.count,
                  rawData: res.response.list,
                },
              });
            } else {
              return failedSenderList();
            }
          }),
          catchError(() => of(failedSenderList()))
        )
      )
    );
  });

  updateFilter$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateSenderListFilter),
      concatLatestFrom(() => this.store.select(selectSenderListFilter)),
      switchMap(([action, prevFilter]) =>
        of(fetchSenderList({ filter: { ...prevFilter, ...action.filter } }))
      )
    );
  });

  constructor(
    private store: Store,
    private readonly actions$: Actions,
    private readonly senderService: SenderService
  ) {}
}
